import React from "react";
import { useTranslation } from "react-i18next";
import { Menu, MenuItem } from "@material-ui/core";
import { LabelButton } from "./ButtonDropdown.styled";
import { useMenu } from "hooks";

export interface DropdownMenuItem {
    id: string;
    label: string;
}

interface ButtonDropdownProps {
    label: string | JSX.Element;
    labelColor?: string;
    items: DropdownMenuItem[];
    skipTabIndexing?: boolean;
    onSelect(item: DropdownMenuItem): void;
}

export const ButtonDropdown: React.FC<ButtonDropdownProps> = ({
    label,
    labelColor,
    items,
    skipTabIndexing,
    onSelect,
}) => {
    const { t } = useTranslation();
    const { anchorEl, handleClose, handleOpen, open } = useMenu();

    //eslint-disable-next-line
    const selectItem = (item: DropdownMenuItem) => (e: any) => {
        onSelect(item);
        handleClose(e);
    };

    return (
        <>
            <LabelButton
                onClick={handleOpen}
                colour={labelColor}
                tabIndex={skipTabIndexing ? -1 : undefined}
                disableRipple>
                {label}
            </LabelButton>
            <Menu
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}>
                {items.map((item) => (
                    <MenuItem key={item.id} onClick={selectItem(item)}>
                        {t(item.label.toUpperCase())}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
